import React, { useEffect, useState } from 'react'
import general from '../../../general'
import Dialog from '../../../lib/Dialog'
import './css/GrowthRecord.css'
import { useScroll } from 'ahooks'
import $ from 'jquery'

export default function GrowthRecord(props) {

  const [list, setList] = useState([])
  const [init, setInit] = useState(false)
  const [page, setPage] = useState(1)
  const [more, setMore] = useState(true)
  const [loading, setLoading] = useState(false)

  const scroll = useScroll()

  useEffect(() => {
    if (props.active && init) {
      if (scroll.top < -80) {
        getData({ page: 1 });
      }

      if (scroll.top + window.innerHeight + 20 > $(document).height() && more) {
        getData({ page: page + 1 });
      }
    }
  }, [props.active, scroll])

  const getData = (params = {}) => {
    if (loading){
      return
    }
    setLoading(true)
    Dialog.loading()
    general.axios.post('/honorRecords', {
      pagination: {
        count: 20,
        page: params.page
      }
    })
      .finally(() => {
        Dialog.close()
      })
      .then(res => {
        const { status, data } = res.data
        if (status.succeed) {
          setLoading(false)
          setInit(true)
          setList(list => params.page == 1 ? data.dataList : [...list, ...data.dataList]);
          params.page && setPage(params.page);
          setMore(data.paginated.more && data.dataList.length > 0);
        } else {
          Dialog.error(status.error_desc)
        }
      })
  }

  useEffect(() => {
    if (props.active) {
      getData({ page })
    }
  }, [props.active])

  return (
    <div className="growth-record-index">
      <div className="growth-record-header">
        <div className="time">时间</div>
        <div className="time">荣誉值（个）</div>
        <div className="time">游戏名称</div>
      </div>
      <div className="growth-record-list">
        {list.map((item, index) => (
          <div key={index} className="growth-record-item">
            <div className="time">{item.time}</div>
            <div className="time">{item.amount}</div>
            <div className="time">{item.remark}</div>
          </div>
        ))}
      </div>
      {list.length == 0 && true && <div className="recovery-empty">
        <img src="/resources/user/bill_empty.png" alt="" />
        暂无数据
      </div>}
      {list.length > 0 && !more ? <div className="view-end">别撩啦！已经到底啦~</div> : null}
    </div>
  )
}
